<button
  *ngIf="options.closeButton"
  (click)="remove()"
  class="toast-close-button"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }} <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>
<div
  *ngIf="message && options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [innerHTML]="message"
>
  <p [innerHTML]="message"></p>
</div>
<div
  *ngIf="message && !options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [attr.aria-label]="message"
>
  {{ message }}
  <div class="toastActions">
    <sn-icon-button matTooltip="Refresh">
      <sn-icon style="color: black" size="sm">refresh</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      [matMenuTriggerFor]="snoozeMenu"
      matTooltip="Snooze Notifications"
      (click)="$event.stopPropagation()"
    >
      <sn-icon style="color: black" size="sm">notifications_paused</sn-icon>
    </sn-icon-button>
    <mat-menu #snoozeMenu="matMenu">
      <button mat-menu-item (click)="snoozeNotificationsTime = 10; remove()">
        <span>10 mins</span>
      </button>
      <button mat-menu-item (click)="snoozeNotificationsTime = 20; remove()">
        <span>20 mins</span>
      </button>
      <button mat-menu-item (click)="snoozeNotificationsTime = 30; remove()">
        <span>30 mins</span>
      </button>
    </mat-menu>
  </div>
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
